import useGetNewspaper from './useGetNewspaper'
export default useGetNewspaper
